import {enConfig} from './en';

export const cnConfig = {
    ...enConfig.base,
    bismi:'以真主的名义，至仁至',
    salaam:'愿你平安',
    header:{
        signup : "注册 更健康",
        signin : "登录",    
        signout : "退出",
        close: "关闭",
        profile: "个人资料",
    },
    
    home:{
        title : '数字化',
        article : '文章',
        contact : '联系',
        about: '关于',

        connected: '您必须注册'
    },

    blog: {
        ...enConfig.blog,
        title :'最有趣的文章',
    },

    about:{
        title:'更健康',
        content:'利用科技和人工智能让人们更健康',
    },

    contact:{
        title:'联系我们',
        message:'请填写下面的表格给我们发送电子邮件',
        confirm:'联系确认',
        content:'请填写我们通过电子邮件发送给您的代码以确认它',
        recipient:"请确认收件人的信息。",
        feedback : '我们已收到您的消息，我们会尽快回复您',
        warning : "需要在继续之前确认您的电子邮件"
    },

    getApp : {
        name : '下载服务应用程序',
        info : '下载服务应用程序',
        label : '下载服务应用程序'
    },

}
